// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__23P0J","bigColWidth":"Table_bigColWidth__XhI5U","biggerColWidth":"Table_biggerColWidth__10AxQ","row":"Table_row__1mCZv","col":"Table_col__3u0-Q"};